import { render, staticRenderFns } from "./FormTaxOtherDocument.vue?vue&type=template&id=6babff99"
import script from "./FormTaxOtherDocument.vue?vue&type=script&lang=js"
export * from "./FormTaxOtherDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports